import { Group } from '@vx/group';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

function callOrValue(maybeFn, data) {
  if (typeof maybeFn === 'function') {
    return maybeFn(data);
  }
  return maybeFn;
}

function additionalProps(restProps, data) {
  return Object.keys(restProps).reduce(function (ret, cur) {
    ret[cur] = callOrValue(restProps[cur], data);
    return ret;
  }, {});
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

HeatmapCircle.propTypes = {
  data: PropTypes.array,
  gap: PropTypes.number,
  step: PropTypes.number,
  radius: PropTypes.number,
  xScale: PropTypes.func,
  yScale: PropTypes.func,
  colorScale: PropTypes.func,
  opacityScale: PropTypes.func,
  yBin: PropTypes.func,
  bin: PropTypes.func,
  bins: PropTypes.func,
  count: PropTypes.func
};

function HeatmapCircle(_ref) {
  var className = _ref.className,
      data = _ref.data,
      _ref$gap = _ref.gap,
      gap = _ref$gap === undefined ? 1 : _ref$gap,
      _ref$step = _ref.step,
      step = _ref$step === undefined ? 0 : _ref$step,
      _ref$radius = _ref.radius,
      radius = _ref$radius === undefined ? 6 : _ref$radius,
      xScale = _ref.xScale,
      yScale = _ref.yScale,
      colorScale = _ref.colorScale,
      _ref$opacityScale = _ref.opacityScale,
      opacityScale = _ref$opacityScale === undefined ? function (d) {
    return 1;
  } : _ref$opacityScale,
      yBin = _ref.yBin,
      _ref$bin = _ref.bin,
      bin = _ref$bin === undefined ? function (d, i) {
    return d.bin;
  } : _ref$bin,
      _ref$bins = _ref.bins,
      bins = _ref$bins === undefined ? function (d, i) {
    return d.bins;
  } : _ref$bins,
      _ref$count = _ref.count,
      count = _ref$count === undefined ? function (d) {
    return d.count;
  } : _ref$count,
      restProps = objectWithoutProperties(_ref, ['className', 'data', 'gap', 'step', 'radius', 'xScale', 'yScale', 'colorScale', 'opacityScale', 'yBin', 'bin', 'bins', 'count']);

  yBin = yBin || bin;
  var r = radius - gap;
  return React.createElement(
    Group,
    null,
    data.map(function (d, i) {
      return React.createElement(
        Group,
        { key: 'heatmap-' + i, className: 'vx-heatmap-column', left: xScale(bin(d, i)) },
        bins(d, i).map(function (b, j) {
          return React.createElement('circle', _extends({
            key: 'heatmap-tile-circle-' + j,
            className: cx('vx-heatmap-circle', className),
            fill: colorScale(count(b)),
            r: r,
            cx: radius,
            cy: yScale(yBin(b, j) + step) + radius,
            fillOpacity: opacityScale(count(b))
          }, additionalProps(restProps, {
            bin: b,
            index: j,
            datum: d,
            datumIndex: i,
            data: data
          })));
        })
      );
    })
  );
}

HeatmapRect.propTypes = {
  data: PropTypes.array,
  binWidth: PropTypes.number,
  binHeight: PropTypes.number,
  x: PropTypes.number,
  gap: PropTypes.number,
  step: PropTypes.number,
  xScale: PropTypes.func,
  yScale: PropTypes.func,
  colorScale: PropTypes.func,
  opacityScale: PropTypes.func,
  yBin: PropTypes.func,
  bin: PropTypes.func,
  bins: PropTypes.func,
  count: PropTypes.func
};

function HeatmapRect(_ref) {
  var className = _ref.className,
      data = _ref.data,
      binWidth = _ref.binWidth,
      binHeight = _ref.binHeight,
      _ref$x = _ref.x,
      x = _ref$x === undefined ? 0 : _ref$x,
      _ref$gap = _ref.gap,
      gap = _ref$gap === undefined ? 1 : _ref$gap,
      _ref$step = _ref.step,
      step = _ref$step === undefined ? 0 : _ref$step,
      xScale = _ref.xScale,
      yScale = _ref.yScale,
      colorScale = _ref.colorScale,
      _ref$opacityScale = _ref.opacityScale,
      opacityScale = _ref$opacityScale === undefined ? function (d) {
    return 1;
  } : _ref$opacityScale,
      yBin = _ref.yBin,
      _ref$bin = _ref.bin,
      bin = _ref$bin === undefined ? function (d, i) {
    return d.bin;
  } : _ref$bin,
      _ref$bins = _ref.bins,
      bins = _ref$bins === undefined ? function (d, i) {
    return d.bins;
  } : _ref$bins,
      _ref$count = _ref.count,
      count = _ref$count === undefined ? function (d) {
    return d.count;
  } : _ref$count,
      restProps = objectWithoutProperties(_ref, ['className', 'data', 'binWidth', 'binHeight', 'x', 'gap', 'step', 'xScale', 'yScale', 'colorScale', 'opacityScale', 'yBin', 'bin', 'bins', 'count']);

  yBin = yBin || bin;
  var width = binWidth - gap;
  var height = binHeight - gap;
  return React.createElement(
    Group,
    null,
    data.map(function (d, i) {
      return React.createElement(
        Group,
        { key: 'heatmap-' + i, className: 'vx-heatmap-column', left: xScale(bin(d, i)) },
        bins(d, i).map(function (b, j) {
          return React.createElement('rect', _extends({
            key: 'heatmap-tile-rect-' + j,
            className: cx('vx-heatmap-rect', className),
            fill: colorScale(count(b)),
            width: width,
            height: height,
            x: x,
            y: yScale(yBin(b, j) + step) + gap,
            fillOpacity: opacityScale(count(b))
          }, additionalProps(restProps, {
            bin: b,
            index: j,
            datum: d,
            datumIndex: i,
            data: data
          })));
        })
      );
    })
  );
}

export { HeatmapCircle, HeatmapRect };



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/@vx/heatmap/dist/vx-heatmap.es.js
// module id = M4U9
// module chunks = 0